<template>
  <div class="billing-filter">
    <h1>Showing from {{ startDateString }} to {{ endDateString }}</h1>
    <div class="right-controls">
      <el-checkbox v-model="profit">Show profits</el-checkbox>
      <el-checkbox style="margin-right: 20px;" v-model="deficit">Show deficits</el-checkbox>
      <el-button type="primary" @click="showTransactionFilterDialog = true" :plain="!customDate">Select month</el-button>
      <el-button type="primary" @click="lastMonth = true" :plain="!lastMonth">Last month</el-button>
      <el-button type="primary" @click="currentMonth = true" :plain="!currentMonth">This month</el-button>
    </div>

     <el-dialog :append-to-body="true" :visible.sync="showTransactionFilterDialog" width="400px" custom-class="dialog-no-padding dialog-invert">
      <div class="transaction-filter-dialog">
        <el-date-picker
          v-model="month"
          type="month"
          placeholder="month">
        </el-date-picker>
        <el-button type="primary" @click="customDate = true">Filter</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showTransactionFilterDialog: false,
      profit: true,
      deficit: true,
      month: null,
      lastMonth: false,
      currentMonth: true,
      customDate: false
    }
  },
  watch: {
    customDate (val) {
      if (val) {
        this.currentMonth = false
        this.lastMonth = false
        this.showTransactionFilterDialog = false
        const lastDate = new Date(this.month.getFullYear(), this.month.getMonth() + 1, 0)
        this.$emit('date', [this.month, lastDate])
      }
    },
    lastMonth (val) {
      if (val) {
        this.customDate = false
        this.currentMonth = false
        this.month = null
        const date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth() - 1
        if (date.getMonth() === 0) {
          year = date.getFullYear() - 1
          month = 11
        }
        this.month = new Date(year, month, 1)
        this.$emit('date', [new Date(year, month, 1), new Date(date.getFullYear(), (month === 11 ? 0 : month + 1), 0)])
      }
    },
    currentMonth (val) {
      if (val) {
        this.month = null
        const date = new Date()
        this.customDate = false
        this.lastMonth = false
        this.$emit('date', [new Date(date.getFullYear(), date.getMonth(), 1), new Date(date.getFullYear(), date.getMonth() + 1, 0)])
      }
    },
    profit (val) {
      this.$emit('filter-profit', val)
    },
    deficit (val) {
      this.$emit('filter-deficit', val)
    }
  },
  computed: {
    startDateString () {
      console.log(this.month)
      const date = new Date()
      return this.month ? this.formatDate(this.month) : this.formatDate(new Date(date.getFullYear(), date.getMonth(), 1))
    },
    endDateString () {
      const date = new Date()
      return this.month ? this.formatDate(new Date(this.month.getFullYear(), this.month.getMonth() + 1, 0)) : this.formatDate(new Date(date.getFullYear(), date.getMonth() + 1, 0))
    }
  },
  methods: {
    formatDate (date) {
      return date.toDateString().split(' ').splice(1).join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
  .transaction-filter-dialog {
    display: flex;
    align-items: center;

    div {
      width: 100%;
    }

    button {
      height: 50px;
    }
  }

  .billing-filter {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .right-controls {
      margin-left: auto;
    }

    h1 {
      color: $text-light;
      font-size: 14px;
      margin: 0;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/billing-overview/Filter.vue